import React, { useState, useEffect } from "react";
import ButtonComponent from "../../../components/common/button/Button"
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Modal from "../../../components/common/modal/Modal";
import './WorkflowStatusModal.css';
import axios from "axios";
import { useMsal } from "@azure/msal-react";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";

const CustomIcon = (props) => {

  const { icon, status, data } = props;
  const getIcon = () => {
    if (status === 'Rejected') {
      return <CloseIcon style={{ color: 'white' }} className="MuiSvgIcon-root" />;
    } else if (status === 'Rejected to Initiator') {
      return <CloseIcon style={{ color: 'white' }} className="MuiSvgIcon-root" />;
    }else if (status.includes("Recalled")) {
      return <CloseIcon style={{ color: 'white' }} className="MuiSvgIcon-root" />;
    }  else if (status === 'Pending') {
      return <AccessTimeIcon style={{ color: 'white' }} className="MuiSvgIcon-root" />;
    } else if (status === 'Re-submitted') {
      return <DoneIcon style={{ color: 'white' }} className="MuiSvgIcon-root" />;
    } else if (status === 'Approved') {
      return <DoneIcon style={{ color: 'white' }} className="MuiSvgIcon-root" />;
    } else if (status === 'Initiated') {
      return <DoneIcon style={{ color: 'white' }} className="MuiSvgIcon-root" />;
    } else if (icon === 1 || icon === data.length) {
      return <FiberManualRecordIcon style={{ color: 'black' }} className="MuiSvgIcon-root" />;
    } else {
      return <FiberManualRecordIcon />;
    }
  };

  return (
    <div className="MuiStepIcon-root Mui-rejected">
      {getIcon()}
    </div>
  );

}
const WorkFlowStatus = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { instance } = useMsal();
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const account = instance?.getAllAccounts()[0]; // get the first account if there are multiple
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"], // You can specify additional scopes
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    const getDataUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/lt/ltWorkflowHistory/${props?.data?.runOutputSeqId}`;
    setLoading(true);
    axios.get(getDataUrl,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`, //the token is a variable which holds the token
          withCredentials: true
        },
        params: {
          plant: localStorage.getItem("selectedLTPlantCode"),
          userEmail: localStorage.getItem("data"),
          ltRole: localStorage.getItem("LTRole"),
          cdRole: localStorage.getItem("CDRole"),
          ltRegion: localStorage.getItem("LTRegion")
        }
      }
    )
      .then(response => {
        setData(response?.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching the data:', error);
        setLoading(false);
        toast.error(error, {
          autoClose: 2000,
        });
      });
  }

  return (
    <div className="workFlowStatus-content-modal">
      <div style={{ margin: '10px 0px' }}>
        <p style={{ marginBottom: '5px' }}>Status</p>
        <span style={{ marginLeft: '10px' }}><b>{props?.data?.currentStatus}</b></span>
      </div>
      {
        loading ? <div style={{ width: 500, height: 210, display: 'flex', justifyContent: 'center', alignItems: 'center' }}> <CircularProgress color="inherit" /></div>
          :
          <div className="workflow-status-container">
            <div>
              <Stepper
                orientation="vertical">
                {data?.map((step, index) => (
                  <Step
                    key={step.label} expanded={true}>
                    <StepLabel
                      StepIconComponent={(props) => <CustomIcon {...props} status={step.wfStatus} data={data} />}
                    >
                      {step.wfTitle}
                    </StepLabel>
                    <StepContent >
                      <div className="approver-status-card">
                         <div className="workflow-header status-header">
                          <div>Date</div>
                          <div>Process</div>
                          <div>Action Performed by</div>
                          <div>Recommended LT to be Updated in S/4</div>
                          <div>Status</div>
                          <div>Approval/Reject Remarks</div>
                        </div>
                        <div className={`workflow-header ${step.wfStatus === "Pending" ? "status-pending-values" : "status-values"}`}>
                          <div>{step.createdTsp || "-"}</div>
                          <div> {step.wfProcess || "-"} </div>
                          <div>{step.wfActorId || "-"}</div>
                          <div>{step.userLt || "-"}</div>
                          <div>{step.wfStatus || "-"}</div>
                          <div> {step.remarks || "-"} </div>
                        </div>
                      </div>
                    </StepContent>
                  </Step>
                ))
                }
              </Stepper>
            </div>
          </div>
      }

    </div>
  )
}


const WorkFlowStatusFooter = (props) => {
  return (
    <div className='footer-btn-wrapper'>
      <ButtonComponent
        maxWidth="170px"
        label="Close"
        bgColor="black"
        color="white"
        onClick={props.onClosePopup}
      />
    </div>
  )
}

const WorkFlowStatusModel = (props) => {
  const [showPopup, setShowPopup] = useState(false);
  const onhandlePopup = () => {
    setShowPopup(true)
  }
  const onClosePopup = () => {
    setShowPopup(false)
  }
  return (
    <div >
      <span style={{ color: "black", cursor: 'pointer', textDecoration: 'underline' }} onClick={onhandlePopup}>{props.value}</span>
      <Modal className="workflowStatusFullModal" open={showPopup} handleClose={onClosePopup} title="Current Status" action={<WorkFlowStatusFooter onClosePopup={onClosePopup} />} content={<WorkFlowStatus data={props.data} />} />
    </div>
  )
}

export default WorkFlowStatusModel